import { render, staticRenderFns } from "./ColumnVideo.vue?vue&type=template&id=f044d432&scoped=true&"
import script from "./ColumnVideo.vue?vue&type=script&lang=js&"
export * from "./ColumnVideo.vue?vue&type=script&lang=js&"
import style0 from "./ColumnVideo.vue?vue&type=style&index=0&id=f044d432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f044d432",
  null
  
)

export default component.exports